import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "yn50b2qb",
  dataset: "production",
  useCdn: true,
});
